export default "__VITE_ASSET__DbA0YPFo__"